import { useCallback, useMemo } from 'react';
import styles from './estimatedSavingBlock.module.css';
import { Box, Flex } from '@chakra-ui/react';
import { MoneyBagIcon } from '@spotoninc/nexus-web-assets';
import { toAmountString } from '../tasks.utils';

function EstimatedSavingBlock({ impact = 0, impactFrequency = 'monthly' }) {
  const annualImpact = useMemo(() => {
    return impactFrequency === 'monthly' ? impact * 12 : impact;
  }, [impact, impactFrequency]);

  const potentialImpact = useMemo(() => {
    return impactFrequency === 'monthly' ? impact : impact / 12;
  }, [impact, impactFrequency]);

  // Helper function to get value class based on positive/negative value
  const getValueClass = useCallback(value => {
    const numValue = parseFloat(value);
    if (numValue > 0) {
      return `${styles.value} ${styles.positive}`;
    } else if (numValue < 0) {
      return `${styles.value} ${styles.negative}`;
    }
    return styles.value; // neutral for zero
  }, []);

  return (
    <Box className={styles.container} p={6}>
      <Flex direction={'row'} alignItems={'center'} gap={'16px'} mb={'16px'}>
        <MoneyBagIcon className={styles.icon} />
        <Box className={styles.title}>Estimated Impact</Box>
      </Flex>

      <Flex
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        gap={'16px'}
      >
        <Box className={styles.label}>{'Potential impact'}</Box>
        <Box className={getValueClass(potentialImpact)}>
          {toAmountString(potentialImpact)}
        </Box>
      </Flex>
      <Flex
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        gap={'16px'}
      >
        <Box className={styles.label}>{'Annual impact'}</Box>
        <Box className={getValueClass(annualImpact)}>
          {toAmountString(annualImpact)}
        </Box>
      </Flex>
    </Box>
  );
}

export default EstimatedSavingBlock;
